import React, {useEffect} from 'react';
import $ from "jquery";
import {GET_COLLECTION_AGGREGATE_DATA} from "../../api";
import cogoToast from "cogo-toast";
import provincials from "data/administrative/provincials.json";
import constituencies from "data/administrative/constituencies.json";
import wards from "data/administrative/wards.json";
import pollings from "data/administrative/pollings.json";
import {useSelector} from "react-redux";

let searchableFields = [
    { field: 'username', isNumeric: false },
    { field: 'name', isNumeric: false },
    { field: 'role', isNumeric: false }
]

let type = null;

const DTAgent = ({id, group_id}) => {
    const token = localStorage.getItem('jwtToken');

    console.log(group_id)

    useEffect(() => {
        let table = $('#agent-table').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Membership Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "agent",
                        searchableFields,
                        filter: {
                            group: group_id || 1
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.username;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            standard : `<span class="badge badge-info tx-white text-capitalize">${data.role}</span>`,
                            administrative : `<span class="badge badge-success tx-white text-capitalize">${data.role}</span>`,
                            ward : `<span class="badge badge-secondary tx-white text-capitalize">${data.role}</span>`,
                            constituency : `<span class="badge badge-primary tx-white text-capitalize">${data.role}</span>`,
                            special : `<span class="badge badge-warning tx-white text-capitalize">${data.role}</span>`
                        }[data.role];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-danger tx-white">Inactive</span>`
                        }[data.active];
                    },
                    "targets": 4
                }
            ]
        });

        $('#agent-table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const mappedItems = (d?.raw.admin_level || [])
                .map(item => {
                    const resolved = administrativeLevel(item.data, item.model);
                    const text = resolved.map(entry => `${entry.name || 'Unknown'}`).join(', ');

                    return (
                        '<tr>' +
                        '<td class="text-capitalize">' + item.model + ':</td>' +
                        '<td>' + text + '</td>' +
                        '</tr>'
                    );
                }).join('');

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Position:</td>' +
                '<td class="text-capitalize">' + d?.raw.role + '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Contact Number:</td>' +
                '<td>' + d?.raw.mobile_number + '</td>' +
                '</tr>' +
                mappedItems +
                '</table>'
            );
        }

        return () => {
            table.destroy();
            type = null;
        }

    }, [id]);

    const administrativeLevel = (ids, type) => {
        const list = (() => {
            switch (type) {
                case 'administrative': return provincials;
                case 'constituency': return constituencies;
                case 'ward': return wards;
                case 'polling': return pollings;
                default: return [];
            }
        })();

        return (ids || []).map(id => {
            const match = list.find(item => item._id === id);
            return match ? { _id: id, name: match.name } : { _id: id, name: null };
        });
    };

    return (
        <table id="agent-table" className="table" style={{ width: "100%" }}>
            <thead>
            <tr>
                <th></th>
                <th className="wd-25p">Name</th>
                <th className="wd-25p">Username</th>
                <th className="wd-25p">Network</th>
                <th className="wd-25p">Active</th>
            </tr>
            </thead>
        </table>
    );
};

export default DTAgent;
